import { Component } from 'react';

import ComponentImage from "GeneralComponents/ComponentImage";
import contentShowItem from "MiniSiteComponents/Carousel/Carousel.interface";

import Consts from "Interfaces/Consts";
import Direction from 'Interfaces/Directions';

import CustomLinkButton from "GeneralComponents/CustomLinkButton";

import "./Squares.min.css";
import Helper from 'Interfaces/Helper';
import { ContentShowListProps as Props } from 'MiniSiteComponents/ContentShow/ContentShow.interface'
import { decodeHtmlEntities } from '../../../Interfaces/utils/Utils';

const getBreakpointInfo = () => {
    const isDesktop = window.matchMedia("(min-width: 1200px)").matches;
    const tabsNumber = isDesktop ? 6 : window.matchMedia("(min-width: 784px)").matches ? 3 : 2;
    return { isDesktop, tabsNumber };
};

const linkIconType = Direction == "rtl" ? "fa-chevron-left" : "fa-chevron-right";

export default class SquareList extends Component {

    tabsArray: any[] = [];
    tabsPannelArray: any[] = [];
    props: Props;
    resizeTimeout: NodeJS.Timeout | null = null;
    state:
        {
            Title: string;
            ComponentId: string;
            CurrentPageId: string;
            Description: string;
            rows: any[],
            itemsNumberInRow: number,
            isDesktop: boolean,
            tabsNumber: number
        };


    constructor(props: Props) {
        super(props);
        const { isDesktop, tabsNumber } = getBreakpointInfo();

        this.state = {
            ...this.props,
            Title: this.props.title,
            ComponentId: this.props.componentId,
            CurrentPageId: this.props.currentPageId,
            Description: this.props.description,
            rows: [],
            itemsNumberInRow: Math.min(Number(this.props.itemsNumberInRow) || 0, 6),
            isDesktop,
            tabsNumber
        };
        
    }

    componentDidMount() {

        this.setTabs(this.props.items);
        this.setRows();
        var openTabPanels = this.getSquareListElement().querySelectorAll('[role=tabpanel]');
        openTabPanels.forEach(x => this.tabPanelShowMore(x));
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
    }

    handleResize = () => {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        
        this.resizeTimeout = setTimeout(() => {
            const { isDesktop, tabsNumber } = getBreakpointInfo();
            
            if (this.state.isDesktop !== isDesktop || this.state.tabsNumber !== tabsNumber) {
                this.setState({ isDesktop, tabsNumber }, () => {
                    this.setTabs(this.props.items);
                    this.setRows();
                });
            }
        }, 250);
    }

    tabPanelShowMore = (elem) => {
        
        var lastClassName = elem.className;

        window.setInterval(function () { // for show more button
            var className = elem.className;

            if (className !== lastClassName) {

                if (className == 'is-show') {
                    var panelContent = elem.querySelector(".mst-tabItem-contentBody");                 

                    panelContent.ariaExpanded = panelContent.ariaExpanded !== 'true';
                    
                    if (panelContent.clientHeight != panelContent.scrollHeight) {

                        var showMoreBtn = elem.querySelector(`[id*="wrapper-readMore"]`);
                        if (showMoreBtn) {
                            showMoreBtn.className = "d-block mt-3";
                        }

                        const short_content = document.getElementById(elem.id).querySelector(".mst-tabItem-contentShortDesc") as HTMLElement;
                        const content = document.getElementById(elem.id).querySelector(".mst-tabItem-contentBody") as HTMLElement;

                        if (content != null) { Helper.disableTabIndexOfHiddenContent(content, true) }
                        if (short_content != null) { Helper.disableTabIndexOfHiddenContent(short_content, true) }


                    }
                }

                lastClassName = className;
            }
        }, 10);
    }

    componentDidUpdate(prevProps: typeof this.props) {

        if (this.props.items !== prevProps.items) {
            this.setTabs(this.props.items);
            this.setRows();         
        }
        var openTabPanels = this.getSquareListElement().querySelectorAll('[role=tabpanel]');
        openTabPanels.forEach(x => this.tabPanelShowMore(x));

    }

    getNoSearchResultsElement = () => document.getElementById("no-ContentSearchResults-" + this.state.ComponentId);

    getSquareListElement = () => document.getElementById(this.state.ComponentId);

    checkItemsNumber = () => {
        const itemsFromProps = Number(this.state.itemsNumberInRow);
        if (this.state.isDesktop && itemsFromProps > 0) {
            return Math.min(itemsFromProps, 6);
        }
        return this.state.tabsNumber;
    }

    setTabs = (tabsItems: contentShowItem[]) => {

        this.tabsArray = [];
        this.tabsPannelArray = [];      
       
        var tabsInRow = this.checkItemsNumber();
        
        // Calculate Bootstrap column class based on items per row
        const getColClass = (itemsPerRow: number) => {
            const colMap = {
                1: 'col-12',
                2: 'col-6',
                3: 'col-4',
                4: 'col-3',
                5: 'col', // Will use equal width columns for 5 items
                6: 'col-2'
            };
            return colMap[itemsPerRow] || 'col';
        };
        
        const colClass = getColClass(tabsInRow);

        for (let i = 0; i < tabsItems.length; i = i + tabsInRow) {
            var slicedArr = tabsItems.slice(i, i + tabsInRow);

            // Calculate how many empty items needed to fill the row
            const emptyItemsCount = tabsInRow - slicedArr.length;

            this.tabsArray.push(
                <ul role="tablist"
                    key={i}

                    aria-labelledby={`${this.state.ComponentId}-tablist-${i}`}
                    className={`manual ${" justify-content-" + this.props.alignment}`}>
                    {
                        // When alignment is center, add empty li before items to center them
                        this.props.alignment == "center" && emptyItemsCount > 0 && Array.from({ length: Math.floor(emptyItemsCount / 2) }).map((_, index) => (
                            <li key={`empty-start-${i}-${index}`} className={colClass} aria-hidden="true"></li>
                        ))
                    }
                    {
                        slicedArr.map((item, j) => (



                            <li id={`${this.state.ComponentId}-tab-${item.index}`}
                                key={item.index}
                                className={colClass}
                                role="tab"
                                aria-selected="false"
                                aria-controls={`${this.state.ComponentId}-tabpanel-${item.index}`}
                                onKeyDown={this.OnKeydown_tab}>
                                <div className="mst-square-tab-content mx-auto">



                                    {
                                        (item.image?.url) ?
                                            <ComponentImage
                                                image={item.image}
                                                imageClass="mx-auto"
                                                mobileImage={item.mobileImage}
                                                mobileImageClass=""
                                                wrapperDivClass={`mst-tabItem-Img ${this.state.isDesktop ? " mb-3" : "mb-2"}`}
                                                cropAlias="squareImage"
                                            />
                                            :
                                            <div className={`mst-tabItem-Img ${this.state.isDesktop ? " mb-3" : "mb-2"}`}>&nbsp;</div>
                                    }
                                    <div className="mst-tabItem-Title focus">
                                        <span> {item.title}</span>
                                    </div>

                                    {
                                        (!item.content && ((item.link.url.startsWith("/") || item.link.url.startsWith("http") || item.link.url.startsWith("tel:")) || (item.url.startsWith("/") || item.url.startsWith("http")))) ?
                                            (<div className={`mst-tab-linkButton  mt-auto`}>

                                                <CustomLinkButton
                                                    title={this.state.Title}
                                                    pageUrl={item.url}
                                                    link={item.link}
                                                    isBtn={true}
                                                    btnClass={`txt-pallete-color `}
                                                    linkClass={""}
                                                    dir={Direction}
                                                    linkIcon={true}
                                                    charLimit={15}
                                                    linkTarget={this.props.linkTarget} />


                                            </div>
                                            ) :




                                            ((item.content || item.richDescription) &&
                                                <div className="mst-show-more-btn mt-auto">
                                                    <button onClick={(e) => this.OnClick_tab(e, item)}
                                                        tabIndex={0} className="  txt-pallete-color" >{Consts.showMore}<i className={`fa fa-fw ${linkIconType}`} ></i></button>


                                                </div>

                                            )
                                    }
                                </div>
                                <div className="mst-tabItem-triangleUp primary-color mx-auto"></div>

                            </li>
                        ))
                    }
                    {
                        // Add empty li elements to fill the row
                        this.props.alignment != "center" && emptyItemsCount > 0 && Array.from({ length: emptyItemsCount }).map((_, index) => (
                            <li key={`empty-${i}-${index}`} className={colClass} aria-hidden="true"></li>
                        ))
                    }
                    {
                        // When alignment is center, add empty li after items to center them
                        this.props.alignment == "center" && emptyItemsCount > 0 && Array.from({ length: Math.ceil(emptyItemsCount / 2) }).map((_, index) => (
                            <li key={`empty-end-${i}-${index}`} className={colClass} aria-hidden="true"></li>
                        ))
                    }
                </ul>
            )
            this.tabsPannelArray.push(


                slicedArr.map((item, j) => (

                    <div id={`${this.state.ComponentId}-tabpanel-${item.index}`}
                        key={item.index}
                        role="tabpanel"
                        aria-labelledby={`${this.state.ComponentId}-tab-${item.index}`}
                        className="is-hidden">
                        <div className="mst-tabItemContent" >

                            <div className="mst-tabItem-body" >
                                <div className="mst-tabItem-contentHeader">
                                    <button className="mst-tabItem-contentClose" type="button" onClick={(event) => this.onClose(event)} >
                                        <span className="mx-auto">  <i className="icon-minisite-close minisite-font-36" /></span>
                                    </button>
                                    <div className={`mst-tabItem-contentTitle me-5 pe-2`}>{item.title}</div>
                                    <div className="mst-tabItem-contentShortDesc" dangerouslySetInnerHTML={{ __html: decodeHtmlEntities(item.richDescription) }}></div>
                                    {/* <LimitedContent classNames="mst-tabItem-contentShortDesc" htmlContent={item.RichDescription}></LimitedContent> */}
                                    <hr />
                                </div>
                                <div className="mst-tabItem-contentBody collapse" id={`${this.state.ComponentId}-tabItem-content-${item.index}`} aria-expanded="false">
                                    <div dangerouslySetInnerHTML={{ __html: item.content }}></div>

                                    <a role="button" className="mst-btn-Close mt-3 txt-pallete-color" onClick={(e) => this.OnClick_closeMore(e)} >
                                        {Consts.close} <i className="fa fa-fw fa-chevron-up" aria-hidden="true"></i>
                                    </a>


                                </div>



                            </div>
                            <div className="d-none" id={`${this.state.ComponentId}-wrapper-readMore-${item.index}`}>
                                <a role="button" className="mst-showMore collapsed txt-pallete-color" data-toggle="collapse" data-target={`#${this.state.ComponentId}-tabItem-content-${item.index}`} aria-expanded="false" aria-controls={`${this.state.ComponentId}-tabItem-content-${item.index}`}
                                    onClick={(e) => this.OnClick_showMore(e, item)} >
                                    {Consts.showMore} <i className={`fa fa-fw ${linkIconType} `}></i>
                                </a>
                            </div>



                            <CustomLinkButton
                                title={item.title}
                                pageUrl={item.url}
                                link={item.link}
                                isBtn={false}
                                btnClass={"btn mst-btn btn-primary px-auto txt-pallete-color"}
                                linkClass={"txt-pallete-color"}
                                dir={Direction}
                                linkIcon={true}
                                charLimit={-3}
                                linkTarget={this.props.linkTarget}
                            />

                        </div>
                    </div>

                ))
            )

        }


    }

    setRows = () => {
        const rows = [];
        for (let i = 0; i < this.tabsPannelArray.length; i++) {

            rows.push(this.tabsArray[i], this.tabsPannelArray[i]);

        }
        this.setState({ rows });
    }

    onClose = (event) => {

        try {
            this.getSquareListElement().querySelectorAll(`[id*="tabpanel-"]`).forEach(x => x.classList.remove("is-show"));
            this.getSquareListElement().querySelectorAll(`[id*="tabpanel-"]`).forEach(x => x.classList.add("is-hidden"));
            this.getSquareListElement().querySelectorAll(`li[aria-selected="true"]`).forEach(x => x.setAttribute('aria-selected', 'false'));
        }
        catch (e) {
            console.log("exception: " + e.message);
        }
    }

    OnClick_showMore = (event, selectedItem: contentShowItem) => {   
        //remove tab index on hidden context
        const content = document.getElementById(event.target.href.split("#")[1]) as HTMLElement;
        if (content != null) { Helper.disableTabIndexOfHiddenContent(content, false) }

        //hide show more btn
        const showMoreBtnContainer = event.target.parentNode as HTMLElement;       
        showMoreBtnContainer.classList.remove("d-block");
        showMoreBtnContainer.classList.add("d-none");
       

        Helper.handleLinkClicksGA4('SquareList', this.state.Title, selectedItem.title + "- more");
    }

    OnClick_closeMore = (event) => {
        const parent = event.target.parentNode;    
        parent.classList.remove('show');
        
        const showMoreBtn = document.getElementById(parent.id.replace("tabItem-content", "wrapper-readMore")) as HTMLElement;
        showMoreBtn.classList.add("d-block");  

       
    }

    OnClick_tab = (event, selectedItem: contentShowItem) => {        
        this.setSelectedTab(event.currentTarget);
        Helper.handleLinkClicksGA4('SquareList', this.state.Title, selectedItem.title);
    }

    get_tabs = () => document.getElementById(this.state.ComponentId).querySelectorAll('[role=tab]');

    setSelectedTab = (currentTab) => {


        var tabs = this.get_tabs();
        var tabpanels = [];


        for (var i = 0; i < tabs.length; i += 1) {
            var tab = tabs[i];

            var tabpanel = document.getElementById(tab.getAttribute('aria-controls'));


            tab.setAttribute('aria-selected', 'false');
            tabpanels.push(tabpanel);

        }


        for (var i = 0; i < tabs.length; i += 1) {
            var tab = tabs[i];


            if (currentTab.closest("li") === tab) {

                tab.setAttribute('aria-selected', 'true');
                tab.removeAttribute('tabindex');
                tabpanels[i].classList.remove('is-hidden');
                tabpanels[i].classList.toggle('is-show');
                tabpanels[i].querySelector(".mst-tabItem-contentClose").focus();
            } else {
                tab.setAttribute('aria-selected', 'false');
                //  tab.tabIndex = -1;
                tabpanels[i].classList.remove('is-show');
                tabpanels[i].classList.add('is-hidden');
            }
        }

        // }





    }

    OnKeydown_tab = (event) => {

        this.onKeydown(event, event.currentTarget);

    }

    onKeydown = (event, currentTab) => {


        var tgt = currentTab,
            flag = false;

        var tabs = this.get_tabs();


        switch (event.key) {
            case 'ArrowLeft':
                if (Direction == "rtl") {
                    this.moveFocusToNextTab(tgt);
                }
                else {
                    this.moveFocusToPreviousTab(tgt);
                }

                flag = true;
                break;

            case 'ArrowRight':
                if (Direction == "rtl") {
                    this.moveFocusToPreviousTab(tgt);
                }
                else {
                    this.moveFocusToNextTab(tgt);
                }

                flag = true;
                break;

            case 'Home':
                this.moveFocusToTab(tabs[0].id);
                flag = true;
                break;

            case 'End':
                this.moveFocusToTab(tabs[tabs.length - 1].id);
                flag = true;
                break;

            default:
                break;
        }

        if (flag) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    moveFocusToTab = (currentTabID) => {

        var tabBtn = document.getElementById(currentTabID).querySelector(".mst-show-more-btn button");
        var linkBtn = document.getElementById(currentTabID).querySelector(".mst-tab-linkButton a");
        if (tabBtn) {
            (tabBtn as HTMLElement).focus();
        }

        if (linkBtn) {
            (linkBtn as HTMLElement).focus();
        }
        if (!tabBtn && !linkBtn) {
            return;
        }
    }

    moveFocusToPreviousTab = (currentTab) => {
        var index;

        var tabs = this.get_tabs();

        let tabs_arr = Array.from(tabs);



        if (currentTab === tabs[0]) {
            this.moveFocusToTab(tabs[tabs.length - 1].id);
        } else {
            index = tabs_arr.indexOf(currentTab);
            this.moveFocusToTab(tabs_arr[index - 1].id);
        }
    }

    moveFocusToNextTab = (currentTab) => {
        var index;
        var tabs = this.get_tabs();



        let tabs_arr = Array.from(tabs);


        if (currentTab === tabs[tabs.length - 1]) {
            this.moveFocusToTab(tabs[0].id);
        } else {
            index = tabs_arr.indexOf(currentTab);
            this.moveFocusToTab(tabs_arr[index + 1].id);
        }
    }

    render() {

        var itemsInRow = this.checkItemsNumber();
       
        return (
            <article className="mst-content-square-list pb-3">

                {
                    this.props.items.length > 0 &&
                    <div className="mst-square-tabs" >

                            <div className="mx-auto mst-square-tabs-container">
                            {
                                    (this.state.itemsNumberInRow < 6 && this.state.itemsNumberInRow != 0) ? (

                                    this.state.rows.map((item, i) => (                                      
                                        <div className={`${i % itemsInRow + this.state.itemsNumberInRow == 0 ? "tabs" : "tabs-panels"}`} key={i}> {item} </div>
                                    ))

                                ) : (
                                    this.state.rows.map((item, i) => (
                                        <div className={`${i % itemsInRow == 0 || i % itemsInRow == 2 ? "tabs" : "tabs-panels"}`} key={i}> {item} </div>

                                    ))
                                )
                            }

                        </div>

                    </div>
                }


            </article>

        );
    }

}